import { Card, CardBody, Col, Container, Row } from 'reactstrap'
import CreateNewTicketForm from '../../../../Componant/Application/Project/ProjectCreate/CreateNewTicketForm'

const TicketCreateContainer = () => {
  return (
    <Container fluid>
      <Row>
        <Col sm="12">
          <Card>
            <CardBody>
              <CreateNewTicketForm />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  )
}

export default TicketCreateContainer